/**
 * UpgradeIOS — pagina dedicata al paywall iOS (App Store In-App Purchase).
 * Raggiungibile da:
 *   • /dashboard/upgrade (route registrata in App.js)
 *   • bottoni "Passa a Pro" / "Upgrade" via safePricingNavigate()
 *
 * Su web: redirect a /pricing (Stripe). Su iOS native: paywall RevenueCat.
 *
 * iter v30 r145 — Compliance Apple Guideline 3.1.1.
 */
import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { isIOS, isNative } from "@/lib/native";
import IAPPaywall from "@/components/IAPPaywall";
import { useAuth } from "@/lib/auth";

export default function UpgradeIOS() {
  const nav = useNavigate();
  const { user } = useAuth();

  // Su web → Pricing classico Stripe
  if (!isIOS && !isNative) {
    return <Navigate to="/pricing" replace />;
  }

  // Non loggato → login prima
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-[#F1F4ED]" data-testid="upgrade-ios-page">
      {/* Top bar minimale con back button */}
      <div
        className="sticky top-0 z-10 bg-[#F1F4ED]/90 backdrop-blur-md border-b border-neutral-200/60"
        style={{ paddingTop: "max(env(safe-area-inset-top, 0px), 12px)" }}
      >
        <div className="max-w-md mx-auto px-4 py-3 flex items-center justify-between">
          <button
            type="button"
            onClick={() => nav(-1)}
            className="inline-flex items-center gap-1 text-sm text-neutral-700"
            data-testid="upgrade-ios-back"
          >
            <ArrowLeft className="h-4 w-4" />
            Indietro
          </button>
          <span className="text-xs uppercase tracking-wider text-neutral-500">Abbonamento</span>
          <span className="w-12" /> {/* spacer per centrare */}
        </div>
      </div>

      <IAPPaywall onPurchased={() => nav("/dashboard")} />
    </div>
  );
}
